import { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { useFetchAllBikajiOrdersMutation, useUpdateOrderStatusBikajiMutation, } from "../../../features/tenant/Bikaji/BikajiApi";
import toast from "react-hot-toast";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import { useFetchDailyDataMutation } from "../../../features/tenant/Cavin/CavinApi";

const CavinDailyData = () => {
  const [tableDataItems, setTableDataItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const initialRequest = {
    limit: 10,
    offset: 0,
    mobile: "",
    user_id: "",
    date: new Date().toISOString().split("T")[0],
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    let initReq = { ...initialRequest, date: request.date };
    console.log("initReq", initReq);
    setRequest(initReq);
    handleCavinOrdersList(initReq)
  };

  const [
    fetchCavinDailyData,
    {
      data: fetchCavinDailyDataResponse,
      error: fetchCavinDailyDataError,
      isLoading: fetchCavinDailyDataLoading,
    },
  ] = useFetchDailyDataMutation();

  const handleCavinOrdersList = (orderRequest = request) => {
    fetchCavinDailyData({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: orderRequest
    });
  };


  useEffect(() => {

    handleCavinOrdersList();

  }, [limit, offset]);

  useEffect(() => {
    if (
      fetchCavinDailyDataResponse &&
      fetchCavinDailyDataResponse.body
    ) {
      toast.dismiss();
      toast.success(`${fetchCavinDailyDataResponse.message}`, {
        id: "fetchCavinDailyDataResponse",
      });
      console.log(
        "transactionsData  data",
        fetchCavinDailyDataResponse
      );
      const arr = [...fetchCavinDailyDataResponse.body.orders];
      setTableDataItems(arr);

      setTotalRows(fetchCavinDailyDataResponse &&
        fetchCavinDailyDataResponse.body.total_orders ? fetchCavinDailyDataResponse.body.total_orders : 0);

    }

    if (fetchCavinDailyDataError) {
      console.log(
        "transactionsData error",
        fetchCavinDailyDataError
      );
      toast.dismiss();
      toast.error(`${fetchCavinDailyDataError.data.message}`, {
        id: "fetchCavinDailyDataError",
      });
    }
  }, [
    fetchCavinDailyDataResponse,
    fetchCavinDailyDataError,
  ]);

  const columns = [
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Mobile  ",
      selector: (row) => row.mobile,
    },
    {
      name: "User ID",
      width: "250px",
      selector: (row) => row.user_id,
    },
    {
      name: "Date",
      selector: (row) => new Date(row.date).toLocaleString(),
    },
    {
      name: "Order Count",
      selector: (row) => row.order_count,
    },
    {
      name: "Outlet Visit",
      selector: (row) => row.outlet_visit,
    },
    {
      name: "Points",
      selector: (row) => row.points,
    },
    {
      name: "Secondary Value",
      selector: (row) => row.secondary_value,
    }, {
      name: "UBO",
      selector: (row) => row.ubo,
    }, {
      name: "Target Achieved",
      selector: (row) => row.targetachieved ? "Yes" : "No",
    },
  ];
  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Cavin Daily Orders
            <LinksComponent />
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
       
            <div className="flex  space-x-2 ">
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Mobile..."
                    required
                    value={request.mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, mobile: newValue };
                      });
                    }}
                  />
                </div>
              </div>
 <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    User ID
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="User ID..."
                    required
                    value={request.user_id}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, user_id: newValue };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Date
                  </label>
                  <input
                    type="date"
                    id="default-search"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Start Date"
                    value={request.date}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          date: newValue,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="">
                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                  &nbsp;
                </label>

                <div className="flex flex-row  gap-2 ">
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleCavinOrdersList();

                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3">
            {fetchCavinDailyDataLoading && <CircleLoaderComponent />}
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={tableDataItems}
                totalRows={
                  fetchCavinDailyDataResponse &&
                  fetchCavinDailyDataResponse?.body?.total_orders
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CavinDailyData;
